import { get } from "lodash";
import { action, makeObservable, observable } from "mobx";
import { postApi } from "../components/Utility";
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import  config  from "../config";

class EvidenceStore {
    evidence = [];
    offset = 0;
    limit = 50;
    hasMore = true;
    loading = false;
    constructor() {
        makeObservable(this, {
            evidence: observable,
            getEvidence: action
        });
    }

    async getEvidence(data,page = 0, pageSize = 20) {
        //http://localhost:3009/aiDashboard/getAiAlarms?companyId=1526&vehicleId=365874&fromDate=2025-07-15 00:00:00&toDate=2025-08-06 17:47:20
        // const base64Input = await utf8.encode(JSON.stringify(postData));
        // const base2 = JSON.stringify(base64_encode(base64Input));

         const params = {
            ...data,
            page,
            pageSize
        };
        var response = await postApi
            .getClient("")
            .get(config.NodeUrl +"/aiDashboard/getAiAlarms",{//?companyId=1526&vehicleId=365874&fromDate=2025-07-15 00:00:00&toDate=2025-08-06 17:47:20", {
                params,
            });

        if (page === 0) {
            // First load → replace
            this.evidence = response?.data?.data || [];
        } else {
            // Next page → append
            this.evidence = [...this.evidence, ...(response?.data?.data || [])];
        }

    }
    async getVehiclesCompanyId(companyId) {
        var postData = { companyId: companyId };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

        this.getVehiclesUsingCompanyId = response?.data?.data;

        return response?.data?.data;
    }
    async getDriversByCompanyId({ companyId }) {
        var postData = { companyId: companyId };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=driver&a=getDriverData", "postData=" + base64Input);
        console.log(response, "post");
        this.getDrivers = response?.data?.data;
        return response?.data?.data;
    }
    async getAlarms() {
        var postData = {
        };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=vehicle&a=getAlarmType", "postData=" + base64Input);
       
        this.alarmlist = response?.data?.data;
        return response?.data?.data;
    }
    async getDetailedVideo(data){
        const params = {
            ...data        };
        var response = await postApi
            .getClient("")
            .get(config.NodeUrl +"/aiDashboard/getDetailedVideo",{
                params,
            });

            // console.log(response?.data)
        return response?.data?.data;
    }
}
export default EvidenceStore;